var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1209 15.0159L10.7604 16.4591C10.5947 17.1194 10.1491 17.6759 9.54007 17.9804L7.75273 18.8741C6.53473 19.4831 5.6434 20.5937 5.31207 21.9156L4.6669 24.4997H23.3336L22.6872 21.9156C22.3571 20.5937 21.4657 19.4831 20.2466 18.8741L18.4604 17.9804C17.8514 17.6759 17.4046 17.1194 17.2401 16.4591L16.8796 15.0159M15.4002 16.4503C14.5707 17.0722 13.4297 17.0722 12.6002 16.4503C10.5434 14.908 9.33357 12.4872 9.33357 9.91699V9.33366C9.33357 6.75649 11.4231 4.66699 14.0002 4.66699C16.5774 4.66699 18.6669 6.75649 18.6669 9.33366V9.91699C18.6669 12.4872 17.4559 14.908 15.4002 16.4503Z",
    stroke: "#1D1F2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsBlack);
export default __webpack_public_path__ + "static/media/accounts-black.9a478e0344617fe1c252173c876b5ebb.svg";
export { ForwardRef as ReactComponent };